export const radii = {
  small: 4,
  default: 8,
  large: 12,
}
